import { createPortal } from "react-dom";
import styles from "./index.module.scss";
import { 
  CloseSvg,
} from "@/assets/icons";
import { useCommonStore } from "@/stores";

type ModalProps = {
  children: any;
  closeOnMask?: boolean;
  closeVisible?: boolean;
  onClose?: () => void;
}

const Modal = (props: ModalProps) => {
  const {
    children,
    closeOnMask = false,
    closeVisible = true,
    onClose,
  } = props;

  const isMobile = useCommonStore(state => state.isMobile);

  const handleClickMask = () => {
    closeOnMask && onClose?.();
  }

  return createPortal(
    <div
      className={styles["modal"]}
    >
      <div 
        className={styles["mask"]}
        onClick={handleClickMask}
      ></div>

      <div className={styles["content"]}>
        {closeVisible && isMobile === false && (
          <button
            className={styles["close_button"]}
            onClick={onClose}
          >
            <CloseSvg></CloseSvg>
          </button>
        )}

        {children}
      </div>

      <style>{`body { overflow: hidden !important; }`}</style>
    </div>,
    document.body
  )
}

export default Modal;